"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordMessage = void 0;
var react_1 = __importDefault(require("react"));
var il_box_common_1 = require("../il-box/il-box.common");
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var ForgotPasswordMessage = function (_a) {
    var email = _a.email;
    return (react_1.default.createElement(il_box_common_1.ILFormBox, { sx: __assign(__assign({}, il_box_common_1.ILFormBoxArgs.sx), { maxWidth: 470, padding: 0 }) },
        react_1.default.createElement(material_1.Box, { sx: { p: { sm: '1.5rem 0.75rem', md: '2rem 4rem' } } },
            react_1.default.createElement(material_1.Typography, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                }, color: "text.primary", variant: enums_1.TypographyVariantEnum.H2 }, "Thank You"),
            react_1.default.createElement(material_1.Typography, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    mx: { md: 3, xs: 1 },
                    py: 1,
                    textTransform: 'unset',
                }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY1 }, "If an account is associated with"),
            react_1.default.createElement(material_1.Typography, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    mx: { md: 3, xs: 1 },
                    py: 1,
                    fontWeight: 600,
                    textTransform: 'unset',
                }, color: "text.primary", variant: enums_1.TypographyVariantEnum.BODY1 }, email),
            react_1.default.createElement(material_1.Typography, { sx: {
                    justifyContent: 'center',
                    textAlign: 'center',
                    mx: { md: 3, xs: 2 },
                    mt: 1,
                    textTransform: 'unset',
                }, color: "text.secondary", variant: enums_1.TypographyVariantEnum.BODY1 }, "You will receive an email with a link to reset your password."))));
};
exports.ForgotPasswordMessage = ForgotPasswordMessage;
